import { RegisterForm } from '@/components/auth/register-form'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_public/register')({
  component: RegisterPage,
})

function RegisterPage(): JSX.Element {
  return <RegisterForm />
}
